import { unsafeCSS } from "lit";
import ApplicationBar from "@shs/ui-marcom/src/js/application-bar";

import custom from "./custom-application-bar.scss";

export default class CustomApplicationBar extends ApplicationBar {
  static get styles() {
    return [super.styles, unsafeCSS(custom)];
  }
}

window.customElements.define("custom-application-bar", CustomApplicationBar);
